var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3958 8.38542H14V5.61458H12.4323C12.3108 5.10416 12.1163 4.60591 11.849 4.11979L12.9427 3.02604L10.974 1.05729L9.91667 2.11458C9.50347 1.87153 8.99306 1.66493 8.38542 1.49479V0H5.61458V1.49479C5.00694 1.66493 4.49653 1.87153 4.08333 2.11458L3.02604 1.05729L1.05729 3.02604L2.15104 4.11979C1.9566 4.46007 1.76215 4.95833 1.56771 5.61458H0V8.38542H1.60417C1.75 8.84723 1.9566 9.32118 2.22396 9.80729L1.05729 10.974L3.02604 12.9427L4.22917 11.776C4.52083 11.9462 4.98264 12.1285 5.61458 12.3229V14H8.38542V12.3229C8.96875 12.1528 9.43055 11.9705 9.77083 11.776L10.974 12.9427L12.9427 10.974L11.776 9.80729C12.0434 9.32118 12.25 8.84723 12.3958 8.38542ZM7 8.96875C6.46528 8.96875 6.00347 8.77431 5.61458 8.38542C5.22569 7.99653 5.03125 7.53472 5.03125 7C5.03125 6.46528 5.22569 6.00347 5.61458 5.61458C6.00347 5.22569 6.46528 5.03125 7 5.03125C7.53472 5.03125 7.99653 5.22569 8.38542 5.61458C8.77431 6.00347 8.96875 6.46528 8.96875 7C8.96875 7.53472 8.77431 7.99653 8.38542 8.38542C7.99653 8.77431 7.53472 8.96875 7 8.96875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5e481e32.svg";
export { ForwardRef as ReactComponent };